import { CalendarOutlined } from '@ant-design/icons'
import { List } from 'antd'
import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'

import { formatDate } from '../../helpers/date'
import routes from '../../helpers/routes'
import { Championship } from '../../schemas/Championship'
import './ChampionshipListItem.css'

type ChampionshipListItemProps = {
  admin: boolean
  tenant: string
  championship: Championship
  removeChampionship(id: string): void
}

export const ChampionshipListItem = ({
  admin,
  tenant,
  championship,
  removeChampionship,
}: ChampionshipListItemProps) => {
  const dateLabel =
    !championship.dateTo || championship.dateFrom === championship.dateTo
      ? formatDate(championship.dateFrom)
      : `${formatDate(championship.dateFrom)} – ${formatDate(championship.dateTo)}`

  return (
    <List.Item className="ChampionshipListItem__wrapper" key={championship.name}>
      <List.Item.Meta
        title={
          <React.Fragment>
            <div
              className={classNames('ChampionshipListItem__title', {
                // hidden: !championship.public,
              })}>
              <Link to={routes.championshipResults(tenant, championship.id)}>
                <span>{championship.name}</span>
              </Link>
            </div>
          </React.Fragment>
        }
        description={
          <span>
            <CalendarOutlined /> {dateLabel}
          </span>
        }
      />
    </List.Item>
  )
}



// WEBPACK FOOTER //
// ./src/components/championship/ChampionshipListItem.tsx